import { useUrlState } from "../../../../hooks/useUrlState.js";
import { MAIL_VIEWS, OPEN_MAIL_URL_KEY } from "../../constants.js";
import { useMailStore } from "../../stores/MailStore.js";
import { MailMessageForm } from "../../components/MailMessageForm/index.js";
import { MailSectionTabs } from "./components/MailSectionTabs/index.js";
import { MailMessageListDisplay } from "./components/MailsMessageListDisplay/index.js";
import { MailMessageDisplayModal } from "./components/MailMessageDisplayModal/index.js";
import { useCallback } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Mail/screens/MailScreen/index.tsx
var ContentComponents = ({ onClickMailMessageItem, onNewMailComplete }) => {
	switch (useMailStore((state) => state.view)) {
		case MAIL_VIEWS.NEW: return /* @__PURE__ */ jsx(MailMessageForm, { onComplete: onNewMailComplete });
		default: return /* @__PURE__ */ jsx(MailMessageListDisplay, { onClickMailMessage: onClickMailMessageItem });
	}
};
function MailScreen() {
	const [isMailOpen, setIsMailOpen] = useUrlState("is_mail_open");
	const [openMailMessageId, setOpenMailMessageId] = useUrlState(OPEN_MAIL_URL_KEY);
	const folder = useMailStore((state) => state.folder);
	const setView = useMailStore((state) => state.setView);
	const goBack = useCallback(() => setView(folder), [folder]);
	const handleClickMailItem = useCallback((messageId) => {
		setOpenMailMessageId(messageId);
		setIsMailOpen(true);
	}, []);
	return /* @__PURE__ */ jsxs("div", { children: [
		/* @__PURE__ */ jsx(MailSectionTabs, {}),
		/* @__PURE__ */ jsx(ContentComponents, {
			onClickMailMessageItem: handleClickMailItem,
			onNewMailComplete: goBack
		}),
		isMailOpen && !!openMailMessageId && /* @__PURE__ */ jsx(MailMessageDisplayModal, {
			mailMessageId: openMailMessageId,
			closeHandler: () => {
				setOpenMailMessageId(void 0);
				setIsMailOpen(void 0);
			}
		})
	] });
}
//#endregion
export { MailScreen };

//# sourceMappingURL=index.js.map